<!--<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px border-bottom padding-right-7px padding-left-8px padding-top-8px">

        <div class="row">
          <div class="col-md-1 padding-left-7px" *ngIf="Patientimage">
            <img class="user-image-circle-65px img2 margin-left-6px" [src]="Patientimage" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-md-12">
                <label class="margin-bottom-0px color-Assign font-weight-bold" *ngIf="PatientName">{{PatientName}}</label>

              </div>
              <div class="col-md-1 line-height-3px">
                <label *ngIf="Age" class="margin-bottom-0px font-size-14">{{Age}},</label>
              </div>
              <div class="col-md-4 padding-left-7px line-height-3px">
                <label *ngIf="Gender=='M'" class="margin-bottom-0px font-size-14">
                  Male
                </label>
                <label *ngIf="Gender=='F'" class="margin-bottom-0px font-size-14">
                  FeMale
                </label>

              </div>
              <div class="col-md-12">
                <label class="margin-bottom-0px color-Assign font-weight-bold font-size-14" *ngIf="Branch">{{Branch}}</label>

              </div>
            </div>
                      </div>
          <div class="offset-md-1 col-md-5 padding-right-0px">
            <div class="row font-size-12px">
              <div class="col-md-4  text-align-right padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Bill No </label>
              </div>:
              <div class="col-md-7 padding-right-0px padding-left-10px" *ngIf="Billno">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{Billno}}</label>
              </div>
            </div>
            <div class="row font-size-12px font-size-12px">
              <div class="col-md-4  text-align-right padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Bill Date </label>
              </div>:
              <div class="col-md-7 padding-right-0px padding-left-10px" *ngIf="BillDate">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{BillDate| date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>
          </div>
        </div>





      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate=""  #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">



                <div class="row margin-top-3px">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                    <div class="row margin-bottom-3px">
                      <div class="col-md-5 text-align-right padding-left-0px">
                        <label for="firstName" class="margin-bottom-0px margin-top-3px">Service Description</label>
                      </div>:
                      <div class="col-md-5">
                        <h4 class="margin-bottom-0px margin-top-3px color-item font-weight-bold font-size-16px" *ngIf="ItemName">{{ItemName}}</h4>

                      </div>

                    </div>

                  </div>
                </div>
                <div class="row margin-top-3px">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                    <div class="row margin-bottom-3px">
                      <div class="col-md-5 text-align-right padding-left-0px">
                        <label for="firstName" class="margin-bottom-0px margin-top-3px">Qunatity</label>
                      </div>:
                      <div class="col-md-5">
                        <h4 class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold font-size-16px">1</h4>

                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right padding-left-0px margin-top-3px">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Date</label>
                      </div>
                      <div class="col-md-4 padding-right-0px">

                        <div class="date-form">
                          <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                 name="dp1" [(ngModel)]="ScanDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">

                          <a (click)="d1.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>

                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right padding-left-0px margin-top-3px">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Remarks</label>
                      </div>
                      <div class="col-md-6 padding-right-0px">

                        <CodeTypeValue CodeType="TRRE" id="CurrentSaveServiceItemTrackingStatusRequest.Remarks"
                                       [(ngModel)]="CurrentSaveServiceItemTrackingStatusRequest.Remarks" SelectedValue=""
                                       name="CurrentSaveServiceItemTrackingStatusRequest.Remarks">
                        </CodeTypeValue>

                      </div>

                    </div>

                  </div>
                </div>





              </div>
            </div>




















          </div>
          <div class="modal-footer">
            <button type="submit" [disabled]="!f.valid" (click)="onSubmit()" class="btn actions-btn-prime float-right font-size-13px margin-left-auto">Planned</button>
            <button type="submit" [disabled]="!f.valid" (click)="onSubmit()" class="btn actions-btn-prime float-right font-size-13px">Completed</button>
            <button type="submit" [disabled]="!f.valid" (click)="onSubmit2()" class="btn actions-btn-prime float-right font-size-13px">Cancelled</button>
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>-->
<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px border-bottom padding-right-7px padding-left-8px padding-top-8px">

        <div class="row">
          <div class="col-md-1 padding-left-7px" *ngIf="Patientimage">
            <img class="user-image-circle-65px img2 margin-left-6px" [src]="Patientimage" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <label class="margin-bottom-0px color-Assign font-weight-bold" *ngIf="PatientName">{{PatientName}}</label>

              </div>
              <div class="col-md-1 line-height-3px">
                <label *ngIf="Age" class="margin-bottom-0px font-size-14">{{Age}},</label>
              </div>
              <div class="col-md-4 padding-left-7px line-height-3px">
                <label *ngIf="Gender=='M'" class="margin-bottom-0px font-size-14">
                  Male
                </label>
                <label *ngIf="Gender=='F'" class="margin-bottom-0px font-size-14">
                  FeMale
                </label>

              </div>
              <div class="col-md-12">
                <label class="margin-bottom-0px color-Assign font-weight-bold font-size-14" *ngIf="Branch">{{Branch}}</label>

              </div>
            </div>
          </div>
          <div class="col-md-5 padding-right-0px">
            <div class="row font-size-12px">
              <div class="col-md-4  text-align-right padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Bill No </label>
              </div>:
              <div class="col-md-7 padding-right-0px padding-left-10px" *ngIf="Billno">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{Billno}}</label>
              </div>
            </div>
            <div class="row font-size-12px font-size-12px">
              <div class="col-md-4  text-align-right padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Bill Date </label>
              </div>:
              <div class="col-md-7 padding-right-0px padding-left-10px" *ngIf="BillDate">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{BillDate| date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>
          </div>
        </div>





      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">



                <div class="row margin-top-3px">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                    <div class="row margin-bottom-3px">
                      <div class="col-md-5 text-align-right padding-left-0px">
                        <label for="firstName" class="margin-bottom-0px margin-top-3px">Service Description</label>
                      </div>:
                      <div class="col-md-5">
                        <h4 class="margin-bottom-0px margin-top-3px color-item font-weight-bold font-size-16px" *ngIf="ItemName">{{ItemName}}</h4>
                        <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                       [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                       name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                        </CodeTypeValue>-->
                        <!--<input type="text" class="form-control" placeholder="Test"
                               id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                               name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                               maxlength="100" required>
                        <small class="form-text text-danger"
                               *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                        <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                        </CustomDataByRequestType>-->
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row margin-top-3px" *ngIf="Showunitprice">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                    <div class="row margin-bottom-3px">
                      <div class="col-md-5 text-align-right padding-left-0px">
                        <label for="firstName" class="margin-bottom-0px margin-top-3px">Unit Price</label>
                      </div>:
                      <div class="col-md-5">
                        <h4 class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold font-size-16px" *ngIf="Unitprice">{{Unitprice}}</h4>
                        <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                       [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                       name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                        </CodeTypeValue>-->
                        <!--<input type="text" class="form-control" placeholder="Test"
                               id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                               name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                               maxlength="100" required>
                        <small class="form-text text-danger"
                               *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                        <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                        </CustomDataByRequestType>-->
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right padding-left-0px margin-top-3px">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Remarks</label>
                      </div>
                      <div class="col-md-6 padding-right-0px">

                        <CodeTypeValue CodeType="TRRE" id="CurrentSaveServiceItemTrackingStatusRequest.Remarks"
                                       [(ngModel)]="CurrentSaveServiceItemTrackingStatusRequest.Remarks" SelectedValue=""
                                       name="CurrentSaveServiceItemTrackingStatusRequest.Remarks">
                        </CodeTypeValue>
                        <!--<input type="text" class="form-control" placeholder="Test"
                               id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                               name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                               maxlength="100" required>
                        <small class="form-text text-danger"
                               *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                        <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                        </CustomDataByRequestType>-->
                      </div>

                    </div>

                  </div>
                </div>





              </div>
            </div>




















          </div>
          <div class="modal-footer">
            <button type="submit" [disabled]="!f.valid" (click)="onSubmit()" class="btn actions-btn-prime float-right font-size-13px margin-left-auto">Completed</button>
            <button type="submit" [disabled]="!f.valid" (click)="onSubmit2()" class="btn actions-btn-prime float-right font-size-13px">Cancelled</button>
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>
